import i18next from 'i18next';

i18next.addResources('es', 'FormButtons', {
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  audit: 'Ver Cambios',
  delete: 'Eliminar',
  edit: 'Editar'
});
